import * as React from 'react'
import landingLogo from './img/landing-logo.png'

const ForgotPassword = (props) => {
    return (
        <div style={{ 
            height: '100vh', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            background: 'var(--gradient-hero)',
            position: 'relative'
        }}>
            {/* Декоративный фон */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'radial-gradient(circle at 30% 20%, rgba(255, 107, 53, 0.1) 0%, transparent 50%)',
                pointerEvents: 'none'
            }} />
            
            <div className="form-card" style={{ width: '400px', minWidth: '400px' }}>
                {/* Логотип и заголовок в одной строке */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 'var(--spacing-xl)',
                    paddingBottom: 'var(--spacing-lg)',
                    borderBottom: '1px solid var(--light-gray)'
                }}>
                    <img 
                        src={landingLogo} 
                        alt="XSocks Logo" 
                        style={{
                            width: '60px',
                            height: '60px',
                            objectFit: 'contain',
                            filter: 'drop-shadow(0 4px 12px rgba(255, 107, 53, 0.3))'
                        }} 
                    />
                    <h2 style={{ margin: 0 }}>Password Recovery</h2>
                </div>
                
                <div style={{
                    background: 'var(--dark-gray)',
                    border: '1px solid var(--light-gray)',
                    borderRadius: 'var(--radius-md)',
                    padding: 'var(--spacing-lg)',
                    marginBottom: 'var(--spacing-lg)'
                }}>
                    <p style={{
                        color: 'var(--text-light)',
                        fontSize: 'var(--text-base)',
                        margin: '0 0 var(--spacing-md) 0',
                        lineHeight: '1.5'
                    }}>
                        To recover your password, please contact our support team:
                    </p>
                    
                    <div style={{ marginBottom: 'var(--spacing-md)' }}>
                        <p style={{
                            color: 'var(--primary-orange)',
                            fontSize: 'var(--text-sm)',
                            fontWeight: '600',
                            margin: '0 0 var(--spacing-xs) 0'
                        }}>
                            📧 Email Support
                        </p>
                        <p style={{
                            color: 'var(--text-light)',
                            fontSize: 'var(--text-sm)',
                            margin: '0 0 var(--spacing-sm) 0'
                        }}>
                            <a 
                                href={`mailto:${process.env.REACT_APP_EMAIL}`}
                                style={{
                                    color: 'var(--primary-orange)',
                                    textDecoration: 'none'
                                }}
                            >
                                {process.env.REACT_APP_EMAIL}
                            </a>
                        </p>
                    </div>
                    
                    <div>
                        <p style={{
                            color: 'var(--primary-orange)',
                            fontSize: 'var(--text-sm)',
                            fontWeight: '600',
                            margin: '0 0 var(--spacing-xs) 0'
                        }}>
                            💬 Telegram Support
                        </p>
                        <p style={{
                            color: 'var(--text-light)',
                            fontSize: 'var(--text-sm)',
                            margin: '0'
                        }}>
                            <a 
                                href={`tg://resolve?domain=${process.env.REACT_APP_TG}`}
                                style={{
                                    color: 'var(--primary-orange)',
                                    textDecoration: 'none'
                                }}
                            >
                                @{process.env.REACT_APP_TG}
                            </a>
                        </p>
                    </div>
                </div>
                
                <div className="form-link">
                    <a href="/login">← Back to Sign In</a>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword